import React from "react"
import { DiscountChip, Spinner } from "@silversea-ssc/ui-components-react"
import { Refundability } from "@silversea-ssc/dotcom-read-model-types-fp"
import { t } from "@lingui/macro"
import clsx from "clsx"
import { formatAmount } from "../../../app-core/_common/format/localization"
import { isValidDeposit, useDeposit } from "../useDeposit"
import { useTotalPrice } from "../useTotalPrice"
import { isPresent } from "../../../app-core/_common/checks"
import styles from "./PriceSummary.module.scss"

type Props = {
    //
}

const PriceSummary: React.FC<Props> = () => {
    const totalPrice = useTotalPrice({ extendedLabel: true })
    if (!totalPrice) return null

    const { formattedAmount, formattedOriginalAmount, price } = totalPrice
    const amountOrSpinner =
        price.status == "loading" ? <Spinner color="neutral10" size="small" /> : formattedAmount || ""

    return (
        <div className={styles.container}>
            <dl className={styles.list}>
                <dt className={styles.priceLabel}>{price.label}</dt>
                <dd
                    className={clsx(styles.priceValue, {
                        [styles.discountedAmount]: isPresent(formattedOriginalAmount),
                    })}
                    data-test-id="price-box-amount"
                >
                    {formattedOriginalAmount && (
                        <React.Fragment>
                            <DiscountChip lineThrough background={"transparent"} className={styles.discountedChip}>
                                {formattedOriginalAmount}
                            </DiscountChip>{" "}
                        </React.Fragment>
                    )}
                    {amountOrSpinner}
                </dd>
                <Deposit />
            </dl>
        </div>
    )
}

export const paymentTermsDepositLabel = (depositType: Refundability): string => {
    switch (depositType) {
        case "refundable": {
            return t({
                id: "book-now-deposit-refundable-label",
                message: `Book now with refundable deposit of`,
            })
        }

        case "nonRefundable":
            return t({
                id: "book-now-deposit-non-refundable-content",
                message: `Book now with not refundable deposit of`,
            })

        case "exchangeableForCredit":
            return t({
                id: "book-now-deposit-exchangeable-for-credit-content",
                message: `Book now with convertible deposit to FCC*`,
            })
    }
}

const Deposit: React.FC = () => {
    const { depositType, suitePayment } = useDeposit()

    if (!isValidDeposit(suitePayment)) return null
    const label = depositType ? paymentTermsDepositLabel(depositType) : ""

    return (
        <>
            <dt className={styles.depositLabel}>{label}</dt>
            <dd className={styles.depositValue}>{formatAmount(suitePayment.amount)}</dd>
        </>
    )
}

export default PriceSummary
